import { gql } from '../../../artifacts/gql';

export const logoutMutation = gql(`
  mutation webLogoutMutation ($accessToken: String!, $refreshToken: String!, $terminateSession: Boolean) {
    collectLogout(accessToken: $accessToken, refreshToken: $refreshToken, terminateSession: $terminateSession)
  }
`);
